<template>
  <basic-modal :isOpen="displayResellerModal" :onClose="turnResellerModalOff">
    <div v-if="data.display == 'certList'">
      <reseller-certificate-list />
    </div>
    <div v-else-if="data.display == 'confirmed'">
      <div>
        <h1>Reseller Confirmed</h1>
        <div v-if="getResellerProduct">
          Thanks for your confirmation. Your item has been added to your cart
          and you may continue shopping.
        </div>
        <div v-else>
          Thanks for your confirmation. You may continue shopping.
        </div>
      </div>
    </div>
    <div v-else>
      <h3>Resale Certification Information</h3>
      <div>
        <label class="checkbox-label">
          <input
            @change="
              confirmReseller($event);
              showConfirmationPage($event);
            "
            type="checkbox"
          />
          <span>
            I attest that I have a valid Sales and Use Tax Certificate/Tax
            Exempt Form for resale.
          </span>
        </label>
        <div class="red-help">
          <ul>
            <li>
              I understand that my order can not be shipped unless Gunold holds
              a certificate of resale.
            </li>
          </ul>
        </div>
        <label class="checkbox-label">
          <input
            @change="confirmAndRedirect($event);"
            type="checkbox"
          />
          <span>
            To enjoy Gunold's low wholesale prices, I want to go ahead and take
            a few minutes to complete the online form certifying that I will
            resell products purchased from Gunold.
          </span>
        </label>
      </div>
    </div>
  </basic-modal>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import basicModal from "vue-src/components/global/basic-modal";
import resellerCertificateList from "vue-src/components/global/reseller-certificate-list";
import * as api from "^/IxPlugin/api";

export default {
  name: "reseller-modal",
  data() {
    return {
      data: {
        display: "", // 'certList', 'confirmed', ''
      },
    };
  },
  components: {
    basicModal,
    resellerCertificateList,
  },
  computed: {
    ...mapGetters(["displayResellerModal", "getLocalCartObject", "getResellerProduct"]),
  },
  methods: {
    ...mapMutations(["turnResellerModalOff"]),
    ...mapActions(["refreshCartObject", "addProductToCart", "refreshAllLineitems"]),
    showCertList(event) {
      if (event.currentTarget.checked) {
        this.$set(this.data, "display", "certList");
      }
    },
    showConfirmationPage(event) {
      if (event.currentTarget.checked) {
        this.$set(this.data, "display", "confirmed");
      }
    },
    async confirmAndRedirect(event) {
      await this.confirmReseller(event);
      const snippet = this.$snippet("reseller-redirect", "");
      if (snippet) {
        window.location.href = snippet;
      } else {
        this.showCertList(event);
      }
    },
    async confirmReseller(event) {
      if (event.currentTarget.checked) {
        api.confirmCartReseller(this.getLocalCartObject.id).then((response) => {
          if (response.status === 200) {
            this.refreshCartObject();
            if (this.getResellerProduct) {
              this.addProductToCart(this.getResellerProduct).then(() => this.refreshAllLineitems());
            }
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.red-help {
  color: red;
  font-size: small;
  font-weight: 600;
}
.checkbox-label {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// ixcms/themes/src/vue-src/top-level/reseller-modal.vue